<template>
  <div>
     <!--start location picker modal -->
<div class="modal fade" id="LocationPickerModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="locationPickerLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-introduction rounded-3 padding-bottom-2">
      <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block padding-left-3 padding-right-3">
        <h1 class="text-black mb-0 medium-family float-start text-size-14 text-full-14">Select Location</h1>
        <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('LocationPickerModal')" aria-label="Close"></button>
      </div>
      <div class="modal-body padding-2 position-relative">
        <!-- Location Search Input -->
        <div class="w-100 d-inline-block margin-top-2 position-relative">
          <div class="row">
            <div class="col-xl-10 col-12">
               <form class="position-relative booking-banner" @submit.prevent>
                  <input
                    type="text"
                    v-model="searchQuery"
                    @input="handleInput"
                    placeholder="Search for area, street name, landmark..."
                    class="bg-white box-shadow rounded-3 border-0 text-size-16 text-full-13 w-100"
                  />
                  <a class="position-absolute location-icon" href="javascript:void(0)">
                    <img src="@/assets/images/location-service-icon.svg" alt="Location icon">
                  </a>
                  <i class="fa fa-angle-down position-absolute nav-color angle-right-icon" aria-hidden="true"></i>
              </form>
            </div>
            <div class="col-xl-2 col-12 mt-xl-0 mt-3 
            ps-xl-0">
              <div class="text-end margin-top-2">
                <button
                  type="button"
                  class="btn btn-success px-4 py-2 text-white text-size-14 rounded-3 text-full-14"
                  @click="confirmLocation"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
          <!-- Predictions Dropdown -->
          <div v-if="predictions.length" class="predictions-container position-absolute w-100 margin-top-1 z-3">
            <div 
              v-for="(suggestion, index) in predictions" 
              :key="index"
              class="prediction-item padding-2 text-start bg-white border-bottom cursor-pointer text-full-13 text-size-14"
              @click="selectSuggestion(suggestion)"
            >
              {{ suggestion.description }}
            </div>
          </div>
        </div>

        <!-- Map Section -->
        <!-- <div class="w-100 d-inline-block margin-top-3 rounded-3 overflow-hidden" style="height: 400px;">
          <div id="map" style="width: 100%; height: 100%;"></div>
        </div> -->
        <div class="w-100 d-inline-block map-scroll">
        <div class="w-100 d-inline-block margin-top-3 rounded-3 confirm-location-map">
          <div id="map" style="width: 100%; height: 100%;">
          </div>
           <div v-if="!locationConfirmed" class="position-absolute start-50 translate-middle text-center text-white bg-dark bg-opacity-75 rounded-2"
          style="width: 310px; top: 75%; padding: 0 1rem !important;">
            Move the map to set the exact position
          </div>
        </div>
      </div>
        <div v-if="locationConfirmed" class="w-100 d-inline-block confirm-location-btn">
            <button
              type="button"
              class="btn bg-green px-4 py-2 text-white text-size-14 rounded-3 text-full-14 w-100 d-inline-block"
              @click="confirmPinLocation"
            >
              Confirm Pin Location
            </button>
          </div>
          <div v-else class="w-100 d-inline-block confirm-location-btn">
            <button
              type="button"
              class="btn bg-green px-4 py-2 text-white text-size-14 rounded-3 text-full-14 w-100 d-inline-block disabled"
              @click="confirmPinLocation"
            >
              Confirm Pin Location
            </button>
          </div>
        <!-- Place the button right after the map div -->
      </div>
    </div>
  </div>
</div>
<!--end location picker modal -->
    <div class="w-100 d-inline-block pets-customer-bg-image padding-bottom-4 position-relative pets-service-bg-image">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-xl-6 col-12 col-md-6 col-sm-6 col-lg-6 mb-xl-0 mb-4">
            <div class="w-100 d-inline-block">
              <div id="carouselExampleIndicators" class="carousel slide customer-slider">
                <div class="carousel-indicators">
                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                </div>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="row">
                      <div class="col-12">
                        <div class="w-100 d-inline-block margin-top-2">
                          <p class="nav-color fw-bold text-size-13 text-uppercase margin-bottom-1 family-filson-bold text-full-13">Testimonials
                          </p>
                          <h2 class="half-black fw-bold text-size-20 family-filson-bold margin-bottom-2 text-full-20">Our Happy Customers</h2>
                          <div class="w-100 d-inline-block coma-image margin-top-3">
                            <!-- <img class="mb-xl-0 mb-2" src="@/assets/images/coma-icon.svg" alt="Slide 1" /> -->
                              <img class="mb-xl-0 mb-2" v-lazy="require('@/assets/images/coma-icon.svg')" alt="Slide 1">
                          </div>
                          <p class="mb-0 text-size-14 text-black margin-xl-top-4 
                          family-inter-light mt-xs-2 text-full-13">
                            My cat is very stubborn but they handled her very good, give her a good shower and clean cut.. i love how patient they was with her, I recommend.
                          </p>
                          <div class="row margin-top-4">
                            <div class="col-xl-2 col-3">
                              <div class="w-100 d-inline-block customer-image">
                                <!-- <img class="d-inline-block rounded-5" src="@/assets/images/customer-image.svg" alt="Slide 1" /> -->
                                <img class="d-inline-block rounded-5" v-lazy="require('@/assets/images/customer-image.svg')" alt="Slide 1">
                              </div>
                            </div>
                            <div class="col-xl-10 ps-xl-0 col-9">
                              <div class="w-100 d-inline-block">
                                <p class="mb-0 text-size-13 nav-color text-uppercase fw-bold margin-top-4 inter-bold-family text-full-13">Elvin Gunes Ozdamar</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="row">
                      <div class="col-12">
                        <div class="w-100 d-inline-block margin-top-2">
                          <p class="nav-color fw-bold text-size-13 text-uppercase mb-0 family-filson-bold text-full-13">Testimonials
                          </p>
                          <h2 class="text-black fw-bold text-full-20 family-filson-bold margin-bottom-2 text-size-20">Our Happy Customers</h2>
                          <div class="w-100 d-inline-block coma-image margin-top-3">
                            <img class="mb-xl-0 mb-2" src="@/assets/images/coma-icon.svg" alt="Slide 1" />
                          </div>
                          <p class="mb-0 text-size-14 text-black margin-xl-top-4 
                          family-inter-light mt-xs-2 text-full-13">
                            This is my first time booking with them the haircut of my dog is nice they used hypoalergenic shampoo as i asked them to do. They are professionals, polite and punctual.
                          </p>
                          <div class="row margin-top-4">
                            <div class="col-xl-2 col-3">
                              <div class="w-100 d-inline-block customer-image">
                                <img class="d-inline-block rounded-5" src="@/assets/images/amazing-pet-grooming-pet-care-services.png" alt="amazing pet grooming, pet care services" />
                              </div>
                            </div>
                            <div class="col-xl-10 ps-xl-0 col-9">
                              <div class="w-100 d-inline-block">
                                <p class="mb-0 text-size-13 nav-color text-uppercase fw-bold margin-top-4 inter-bold-family text-full-13">Dana Daaboul</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true">
                    <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="picture" />
                  </span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true">
                    <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="picture" />
                  </span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 mt-xl-0 mt-5 col-md-6 mt-md-0 mt-sm-0 col-sm-6 col-lg-6">
            <div class="w-100 d-inline-block bg-servics-job bg-customer-before margin-top-2">
              <div class="w-100 d-inline-block position-relative">
            <div class="w-100 d-inline-block 
            padding-xl-left-4 mt-xl-0 mt-4">
              <h2 class="half-black fw-bold text-full-20 family-grand mb-2 w-80 family-filson-bold w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-size-20">Book Mobile Pet Grooming at Your Doorstep</h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-12">Book Instantly for Mobile Grooming Services
              </p>
            </div>
          <form @submit.prevent="submitBooking" class="padding-xl-left-4">
                  <div class="row margin-top-3">
                    <div class="col-12 margin-bottom-2">
                      <div class="w-100 d-inline-block customer-form">
                        <input v-model="formData.name" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-12" type="text" placeholder="Your Name" required />
                      </div>
                    </div>
                    <!-- Mobile & Email -->
                    <div class="col-xl-7 col-12 
                    margin-bottom-2">
                       <PhoneNumberInput
                        v-model="formData.phoneNumber"
                        @validation-changed="onPhoneValidationChanged"
                      />
                    </div>
                    <div class="col-xl-5 col-12 
                    margin-bottom-2">
                      <div class="w-100 d-inline-block customer-form">
                        <input v-model="formData.email" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-12" type="email" placeholder="Enter your email (optional)"/>
                      </div>
                    </div>
                  <div class="col-12 margin-bottom-2">
                    <label class="form-label fw-bold w-100 d-inline-block text-full-14 text-size-14">Select Services</label>
                    <multiselect
                      v-model="formData.selected_services"
                      :options="formattedServices"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      placeholder="Select Services"
                      label="label"
                      track-by="id"
                      class="w-100 d-inline-block text-size-16 text-full-12 position-relative"
                    />
                    <div class="mt-2 text-black fw-bold" v-if="totalPrice > 0">
                      Total Price: AED {{ totalPrice }}
                    </div>
                  </div>
                   <!-- Date -->
                  <div class="col-6 margin-bottom-2 pe-xl-0">
                    <div class="position-relative customer-form" @click="openDatePicker">
                      <input
                        v-model="formData.date"
                        class="custom-date bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-12"
                        type="date"
                        :min="minDate"
                        :max="maxDate"
                        placeholder="Select Date"
                        required
                        ref="dateInput"
                        @change="onDateChange"
                      />
                      <img class="custom-calendar-icon" src="@/assets/images/calendar-image-icon.svg" alt="calendar" />
                    </div>
                  </div>
                  <div class="col-6 margin-bottom-2">
                    <!-- Time Slots -->
                    <div class="w-100 d-inline-block customer-form">
                      <select 
                        v-model="formData.selectedSlot"
                        class="form-select w-100 text-size-16 text-full-12 text-black medium-family"
                        required
                      >
                        <option value="" disabled>Select a Time Slot</option>
                        <option 
                          v-for="(slot, index) in timeSlots" 
                          :key="index" 
                          :value="slot"
                          :disabled="!slot.isAvailable"
                        >
                          {{ slot.time }} {{ !slot.isAvailable ? '(Booked)' : '' }}
                        </option>
                      </select>
                    </div>
                  </div>
                     <!-- Pin Location -->
                    <!-- <div class="col-4 margin-bottom-2 pe-0">
                      <div class="w-100 d-inline-block text-center"> 
                        <a @click="initMap" href="javascript:void(0)" class="text-white text-size-14 d-inline-block w-100 text-full-14 bg-green rounded-2 pick-location-btn">Pick Location
                        </a>
                    </div>
                  </div> -->
                    <div class="col-12 margin-bottom-2">
                      <div class="w-100 d-inline-block customer-form position-relative">
                        <input v-model="formData.pin_location" @click="initMap" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-12 pin-location-input" type="text" placeholder="Your pin location" required />
                        <a class="position-absolute location-icon" @click="initMap" href="javascript:void(0)">
                          <img src="@/assets/images/location-service-icon.svg" alt="Location icon">
                        </a>
                    </div>
                  </div>
                    <!-- Address -->
                    <div class="col-12 margin-bottom-2">
                      <div class="w-100 d-inline-block customer-textarea">
                        <textarea
                          v-model="formData.address"
                          class="form-control bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 position-relative text-full-12"
                          rows="4"
                          placeholder="Please enter address like Villa/aprtment and instructions"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <!-- Submit Button -->
                  <div class="row">
                    <div class="col-xl-4 col-12 p-xl-0">
                      <div class="w-100 d-inline-block ps-xl-3 text-xs-center text-md-center">
                        <button
                        type="submit"
                        :disabled="isSubmitting"
                        class="text-white text-size-12 bg-green text-uppercase d-inline-block inter-bold-family text-full-11 submit-now-btn w-xs-100 text-xs-center border-0"
                        >
                        {{ isSubmitting ? 'Booking...' : 'Book Now' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global google */
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PhoneNumberInput from '../PhoneNumberInput.vue';

export default {
  name: 'CustomerBookingForm',
  components: {
    Multiselect, 
    PhoneNumberInput
  },
  
  data() {
    const today = new Date();
    const todayString = today.toISOString().split('T')[0];
    return {
      locationConfirmed: false,
      date: todayString,
      predictions: [],
      timeSlots: [], 
      services: [],
      isSubmitting: false,
      todayDate: today,
      formData: {
        name: '',
        phoneNumber: '',
        email: '',
        selected_services: [],
        date: todayString, // Set today's date by default
        selectedSlot: null, // Will be set to first available slot
        pin_location: '',
        address: ''
      }
    };
  },
  computed: {
    // formattedServices() {
    //   return this.services.map(service => ({
    //     ...service,
    //     label: `${service.name}(${service.category_name} ${service.plan_name} Grooming) (AED ${service.price})`
    //   }));
    // },
    formattedServices() {
      return this.services.flatMap(group =>
        group.services.map(service => ({
          ...service,
          label: `${service.name} - ${service.plan_name} Grooming (AED ${service.price})`
        }))
      );
    },
    minDate() {
      return this.todayDate.toISOString().split('T')[0];
    },
    maxDate() {
      const max = new Date(this.todayDate);
      max.setDate(max.getDate() + 12);
      return max.toISOString().split('T')[0];
    },
    totalPrice() {
      return this.formData.selected_services.reduce((sum, service) => {
        let numericPrice = parseInt(String(service.price).replace(/\D/g, ''), 10);
        return sum + (isNaN(numericPrice) ? 0 : numericPrice);
      }, 0);
    }
  },
  mounted() {
    this.fetchServices();
    this.generateTimeSlots();
  },
  methods: {
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion.description;
      this.address = suggestion.description;
      this.predictions = [];
    },
    confirmPinLocation() {
      if (this.lat && this.lng && this.address) {
        this.formData.pin_location = this.address;
        this.closeModal('LocationPickerModal');
        this.$toast && this.$toast.success('Location selected!');
      } else {
        this.$toast && this.$toast.error('Please select a location on the map.');
      }
    },
    confirmLocation() {
      this.formData.pin_location = this.searchQuery;
      this.closeModal('LocationPickerModal');
    },
    initMap() {
      this.openModal('LocationPickerModal');
      if (window.google && document.getElementById('map')) {
        const defaultLatLng = { lat: 25.2048, lng: 55.2708 };
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: defaultLatLng,
          zoom: 12,
        });
        this.marker = new google.maps.Marker({
          position: defaultLatLng,
          map: this.map,
          draggable: true,
        });

        this.marker.addListener('dragend', (event) => {
          this.locationConfirmed = true;
          this.lat = event.latLng.lat();
          this.lng = event.latLng.lng();
          this.reverseGeocodePin(this.lat, this.lng);
        });

        this.map.addListener('click', (event) => {
          this.marker.setPosition(event.latLng);
          this.lat = event.latLng.lat();
          this.lng = event.latLng.lng();
          this.reverseGeocodePin(this.lat, this.lng);
          this.locationConfirmed = true;
        });
        this.map.addListener('dragend', () => {
          const center = this.map.getCenter();
          this.marker.setPosition(center); // Optional: re-center the marker
          this.lat = center.lat();
          this.lng = center.lng();
          this.locationConfirmed = true;
          this.reverseGeocodePin(this.lat, this.lng);
        });
      }
    },
    async reverseGeocodePin(lat, lng) {
      const geocoder = new google.maps.Geocoder();
      const latLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.address = results[0].formatted_address; 
          } else {
            console.error("No results found");
          }
        } else {
          console.error("Geocoder failed due to:", status);
        }
      });
    },
    openModal(id) {
      const modalElement = document.getElementById(id);
      if (modalElement) {
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        document.body.classList.add('modal-open');
      }
    },
    closeModal(id) {
      const modalElement = document.getElementById(id);
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');

      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }
    },
    async handleInput() {
      if (this.searchQuery.trim().length > 1) {
        const result = await this.searchPlaces(this.searchQuery);
        if (result && result.predictions) {
          this.predictions = result.predictions;
        }
      } else {
        this.predictions = [];
      }
    },
    async searchPlaces(query) {
      try {
        const response = await this.$axios.post("/search-places", { query });
        return response.data;
      } catch (error) {
        console.error('Error fetching places:', error);
        return null;
      }
    },
    async fetchServices() {
      try {
        const response = await this.$axios.post('/booking-services', {
          website_name: this.$websiteName
        });
        if (response.data.success) {
          this.services = response.data.services;
          // console.log('Services fetched on home page:', this.services);
        } else {
          this.$toast.error('Failed to load services');
        }
      } catch (error) {
        console.error(error);
        this.$toast.error('Error fetching services');
      }
    },
    async generateTimeSlots() {
      try {
        const response = await this.$axios.post('/website-timing', {
          appointment_date: this.formData.date,
        });
        if (response.data.success) {
          this.timeSlots = response.data.all_slots.map(slot => ({
            time: slot,
            isAvailable: response.data.available_slots.includes(slot),
          }));
          
          // Auto-select first available slot if none is selected
          if (!this.formData.selectedSlot && this.timeSlots.length > 0) {
            const firstAvailableSlot = this.timeSlots.find(slot => slot.isAvailable);
            if (firstAvailableSlot) {
              this.formData.selectedSlot = firstAvailableSlot;
            }
          }
        } else {
          console.error('Error fetching slots:', response.data.message || 'Unknown error');
          this.timeSlots = [];
        }
      } catch (error) {
        console.error('Error fetching slots:', error);
        this.timeSlots = [];
      }
    },
    onDateChange() {
      // Reset selected slot when date changes
      this.formData.selectedSlot = null;
      this.generateTimeSlots();
    },
    openDatePicker() {
      this.$refs.dateInput.focus();
    },
    async submitBooking() {
      try {
        this.isSubmitting = true;
        const payload = {
          website_name: this.$websiteName,
          name: this.formData.name,
          email: this.formData.email,
          phoneNumber: this.formData.phoneNumber,
          address: this.formData.address,
          pin_location: this.formData.pin_location,
          date: this.formData.date,
          duration_from: this.formData.selectedSlot.time.split('-')[0],
          duration_to: this.formData.selectedSlot.time.split('-')[1],
          service_ids: this.formData.selected_services.map(service => service.id),
          plan_detail_prices_ids: this.formData.selected_services.map(service => service.id),
          item_counts: this.formData.selected_services.map(service => ({ id: service.id, count: 1 })),
          totalPrice: this.totalPrice
        };
        const response = await this.$axios.post('/save-booking', payload);
        this.isSubmitting = false;
        if (response.data.success) {
          this.$toast.success('Booking submitted successfully!');
          const today = new Date().toISOString().split('T')[0];
          this.formData = {
            name: '',
            email: '',
            phoneNumber: '',
            address: '',
            pin_location: '',
            date: today,
            selected_services: [],
            selectedSlot: null
          };
          this.totalPrice = 0;

          // Re-fetch slots for today and auto-select first available
          this.generateTimeSlots();
        } else {
          this.$toast.error('Submission failed');
        }
      } catch (err) {
        this.isSubmitting = false;
        console.error(err);
        this.$toast.error('Error submitting booking');
      }
    },
    onPhoneValidationChanged(isValid) {
      // Handle phone validation if needed
      this.isPhoneValid = isValid;
    }
  }
};
</script>
<style scoped></style>
